import React, { useEffect, useState } from "react";
import { Plus, Trash2, Network, Clock } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { PageHeader, Card, SectionTitle, DemoTag } from "@/components/ui/page";

export default function Processes() {
  const [processes, setProcesses] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [np, setNp] = useState({ name: "", code: "", description: "" });
  const [ns, setNs] = useState({ name: "", start_time: "09:00", end_time: "18:00" });

  const load = () => {
    api.get("/processes").then((r) => setProcesses(r.data));
    api.get("/shifts").then((r) => setShifts(r.data));
  };
  useEffect(() => { load(); }, []);

  const addProc = async () => {
    if (!np.name) return;
    try { await api.post("/processes", np); toast.success("Process added"); setNp({ name: "", code: "", description: "" }); load(); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  const addShift = async () => {
    if (!ns.name) return;
    try { await api.post("/shifts", ns); toast.success("Shift added"); setNs({ name: "", start_time: "09:00", end_time: "18:00" }); load(); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  const delProc = async (id) => { await api.delete(`/processes/${id}`); toast.success("Deleted"); load(); };
  const delShift = async (id) => { await api.delete(`/shifts/${id}`); toast.success("Deleted"); load(); };

  const inputCls = "rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-[#08A7A0]";

  return (
    <div>
      <PageHeader title="Processes & Shifts" subtitle="Configure operational processes and shift timings" testId="processes-header" />
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Card className="p-5" testId="processes-card">
          <div className="flex items-center gap-2"><Network className="h-5 w-5 text-[#08A7A0]" /><SectionTitle>Processes</SectionTitle></div>
          <div className="mt-4 flex flex-wrap gap-2">
            <input data-testid="proc-name" value={np.name} onChange={(e) => setNp({ ...np, name: e.target.value })} placeholder="Process name" className={`flex-1 ${inputCls}`} />
            <input data-testid="proc-code" value={np.code} onChange={(e) => setNp({ ...np, code: e.target.value })} placeholder="Code" className={`w-24 ${inputCls}`} />
            <button data-testid="add-process" onClick={addProc} className="flex items-center gap-1 rounded-lg bg-[#08A7A0] px-3 py-2 text-sm font-bold text-white"><Plus className="h-4 w-4" /></button>
          </div>
          <div className="mt-4 space-y-2">
            {processes.map((p) => (
              <div key={p.id} className="flex items-center justify-between rounded-lg border border-slate-200 px-3 py-2.5">
                <div><span className="font-semibold text-[#0B1F33]">{p.name}</span> {p.is_demo && <DemoTag />}<span className="ml-2 text-xs text-slate-400">{p.code}</span></div>
                <button onClick={() => delProc(p.id)} className="text-slate-400 hover:text-red-500"><Trash2 className="h-4 w-4" /></button>
              </div>
            ))}
          </div>
        </Card>

        <Card className="p-5" testId="shifts-card">
          <div className="flex items-center gap-2"><Clock className="h-5 w-5 text-[#08A7A0]" /><SectionTitle>Shifts</SectionTitle></div>
          <div className="mt-4 flex flex-wrap gap-2">
            <input data-testid="shift-name" value={ns.name} onChange={(e) => setNs({ ...ns, name: e.target.value })} placeholder="Shift name" className={`flex-1 ${inputCls}`} />
            <input data-testid="shift-start" type="time" value={ns.start_time} onChange={(e) => setNs({ ...ns, start_time: e.target.value })} className={inputCls} />
            <input data-testid="shift-end" type="time" value={ns.end_time} onChange={(e) => setNs({ ...ns, end_time: e.target.value })} className={inputCls} />
            <button data-testid="add-shift" onClick={addShift} className="flex items-center gap-1 rounded-lg bg-[#08A7A0] px-3 py-2 text-sm font-bold text-white"><Plus className="h-4 w-4" /></button>
          </div>
          <div className="mt-4 space-y-2">
            {shifts.map((s) => (
              <div key={s.id} className="flex items-center justify-between rounded-lg border border-slate-200 px-3 py-2.5">
                <div><span className="font-semibold text-[#0B1F33]">{s.name}</span> {s.is_demo && <DemoTag />}<span className="ml-2 font-mono text-xs text-slate-400">{s.start_time}–{s.end_time}</span></div>
                <button onClick={() => delShift(s.id)} className="text-slate-400 hover:text-red-500"><Trash2 className="h-4 w-4" /></button>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}
